import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";

import templateContent from "./set-construction-site-worksheet-document.html";

import followUpManager from "../../_shark_jaws/managers/followUpManager";
import disableActionButtonComponent from "../disableActionButton/disableActionButtonComponen";
import { documentManager } from "../../_shark_jaws/managers/documentManager";
import { notComplianceReportManager } from "../../_shark_jaws/managers/notComplianceReportManager";
import { userManager } from "../../_shark_jaws/managers/userManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class SetConstructionSiteWorksheetDocumentComponent extends Component {
	constructor() {
		super("setConstructionSiteWorksheetDocumentComponent");

		this.addTemplate("", templateContent);
	}

	addCSWorksheetBtn_clickHandler (event, data) {
		//Dave: Sarebbe carino usare questo componente anche per preventivi e CSC, così è sempre uguale.. ovviamente dovrà capire dove cercare.
		const currNotComplianceReport = Utils.safp(Shark.get("notComplianceReportList"), "guid", data.guid);

		Shark.set({
			currNotComplianceReport
		});

		this.open();
	}

	beforeRender () {
		this.set({
			__nextCSWorksheetSaveName: Shark.__generateGUID(),
		});
	}

	close () {
		$(`#setConstructionSiteWorksheetDocumentModal`).modal("hide");
	}

	init () {
		this.addComponents([disableActionButtonComponent, waitBoxComponent]);
	
		const currConstructionSiteWorksheet = Shark.getInstance("__smart__", {
			document: null,
			fileName: "",
			__maintainExistingDocument: false,
		});

		Shark.set({
			currConstructionSiteWorksheet
		});
	}

	open (mode) {
		// const currConstructionSiteCard = Shark.get("currConstructionSiteCard");

		this.set({
			__showReplaceCSWorksheetOptions: mode === "replace",
		});

		const currConstructionSiteWorksheet = Shark.get("currConstructionSiteWorksheet");
		currConstructionSiteWorksheet.__maintainExistingDocument = false;

		Shark.render();

		$(`#setConstructionSiteWorksheetDocumentModal`).modal("show");
		// this.set({
		// 	open: true,
		// });
	}

	replaceCSWorksheet_clickHandler (event, data) {
		//Dave: Sarebbe carino usare questo componente anche per preventivi e CSC, così è sempre uguale.. ovviamente dovrà capire dove cercare.
		const currNotComplianceReport = Utils.safp(Shark.get("notComplianceReportList"), "guid", data.guid);

		if (currNotComplianceReport && confirm("Un Foglio Lavoro Cantiere è già stato inviato, sei sicuro di volerlo sostituire?")) {
			Shark.set({currNotComplianceReport});
			this.open("replace");
		}
	}

	setCSWorksheetDocumentModalConfirmBtn_clickHandler () {
		const currConstructionSiteWorksheet = Shark.get("currConstructionSiteWorksheet");

		if (currConstructionSiteWorksheet.document === null) {
			const uploadCSWorksheetBtn = document.querySelector("#uploadCSWorksheetBtn");

			if (uploadCSWorksheetBtn) {
				uploadCSWorksheetBtn.classList.add("btn-danger");
				uploadCSWorksheetBtn.classList.remove("btn-primary");
			}
			return;
		}

		waitBoxComponent.show();

		documentManager.save(currConstructionSiteWorksheet.document)
		.then(saveDocumentResponse => {
			const savedDocument = saveDocumentResponse.data;
			const currNotComplianceReport = Shark.get("currNotComplianceReport");
			const previousDocumentGuid = currNotComplianceReport.extraData.constructionSiteWorksheetDocumentGuid;
			const maintainExistingDocument = currConstructionSiteWorksheet.__maintainExistingDocument;
			
			let newStatus = currNotComplianceReport.status;
			let statusMessage = "";

			if (currNotComplianceReport.status === 4 && currNotComplianceReport.cca !== "") {
				newStatus = 5;
				statusMessage = "Il Cantiere relativo è ora pronto a partire.";
			}
			else if (currNotComplianceReport.status === 1 && currNotComplianceReport.cca === "") {
				newStatus = 4;
				statusMessage = "Il Rapporto di non Conformità è ora in attesa della CCA.";
			}

			currNotComplianceReport.set({
				"extraData.constructionSiteWorksheetDocumentGuid": savedDocument.guid,
				status: newStatus,
			});

			notComplianceReportManager.save(currNotComplianceReport)
			.then(saveComplianceReportResponse => {
				if (previousDocumentGuid && previousDocumentGuid !== "") {
					if (maintainExistingDocument) {
						documentManager.setStatusByGuid(previousDocumentGuid, Document.STATUS_EXPIRED);
					}
					else {
						documentManager.delete2([{guid: previousDocumentGuid}]);
					}
				}
				
				const currUser = Shark.get("currUser");
				const referenceAgent = Utils.safp(Shark.get("userList"), "guid", currNotComplianceReport.userGuid);
				
				//Dave: Qui c'è da rimettere in ordine le cose che faccio sempre, solo quando si aggiorna, solo quando si crea
				// Non mandiamo di nuovo la mail se cambia il documento.
				if (!this.get("__showReplaceCSWorksheetOptions")) {
					const body = `BuonGiorno ${referenceAgent.firstName},
					
						questa eMail per comunicarti che è stato caricato il Foglio Lavoro Cantiere relativo al Rapporto di non Conformità <strong>${currNotComplianceReport.__numberLabel}</strong> con partenza prevista il <strong>${currNotComplianceReport.__startDateLabel}</strong> per il Cliente <strong>${currNotComplianceReport.clientName || currNotComplianceReport.__clientName}</strong>.
						${statusMessage ? "\n" + statusMessage + "\n" : ""}
						Puoi visualizzare il Foglio Lavoro Cantiere <a href="${Shark.get("__cdnURL")}/${savedDocument.fileURL}">cliccando qui</a>.

						Buona Giornata,
						IPM HUB


						<small>Questa eMail è stata generata in automatico, per favore non rispondere.</small>
					`;

					const currMessage = Shark.getInstance(null, {
						body,
						senderEMail: currUser.email,
						senderName: currUser.__fullName,
						subject: "IPM HUB | Foglio Lavoro Cantiere inserito (per Non Conformità)",
						receiverEMail: referenceAgent.email,
						receiverName: referenceAgent.__fullName,
					});
					userManager.sendMessage(currMessage);
				}

				const newFollowUp = Shark.getInstance("ClientFollowUp", {
					body: `Caricato il Foglio Lavoro Cantiere per il Rapporto di non Conformità <strong>${currNotComplianceReport.__numberLabel}</strong>.${statusMessage ? " " + statusMessage : ""}`,
					clientGuid: currNotComplianceReport.clientGuid,
					referenceGuid: currNotComplianceReport.guid,
					referenceType: "notComplianceReport",
					status: 3,
					type: "system"
				});

				if (this.get("__showReplaceCSWorksheetOptions")) {
					newFollowUp.body = `Sostituito il Foglio Lavoro Cantiere per il Rapporto di non Conformità <strong>${currNotComplianceReport.__numberLabel}</strong>.${statusMessage ? " " + statusMessage : ""}`;

					if (maintainExistingDocument) {
						newFollowUp.body += ` Il documento precedente è stato mantenuto in archivio.`;
					}
				}

				followUpManager.save(newFollowUp)
				.then(followUpSaveResponse => {
					//Dave: Abbiamo detto che per le NCR non parte eMail.. giusto?
					// if (newStatus === 5) {
					// 	setTimeout(() => {
					// 		constructionSiteCardManager.checkCommunicateStarting(currNotComplianceReport);
					// 	}, 500);
					// }

					waitBoxComponent.hide();
					this.close();
					Shark.render();
				});
			});
		});
	}

	uploadCSWorksheetBtn_clickHandler () {
		const currNotComplianceReport = Shark.get("currNotComplianceReport");
		
		if (currNotComplianceReport.attachmentFolderGuid.trim() === "") {
			alert("Attenzione!\n\nSi è verificato un errore e non posso proseguire, per favore clicca su 'annulla' e segnala subito l'errore CSWD-UPL-197");
			return;
		}

		document.querySelector("#uploadCSWorksheetField").click();
	}

	uploadCSWorksheetField_changeHandler (event) {
		if (event.target.files.length === 0) {
			return;
		}

		waitBoxComponent.show();

		const uploadCSWorksheetBtn = document.querySelector("#uploadCSWorksheetBtn");

		if (uploadCSWorksheetBtn) {
			uploadCSWorksheetBtn.classList.remove("btn-danger");
			uploadCSWorksheetBtn.classList.add("btn-primary");
		}

		documentManager.upload(event.target)
		.then(uploadDocumentResponse => {
			const uploadedDocument = uploadDocumentResponse.data.documents[0];
			const currConstructionSiteWorksheet = Shark.get("currConstructionSiteWorksheet");
			const currNotComplianceReport = Shark.get("currNotComplianceReport");

			uploadedDocument.set({
				folderGuid: currNotComplianceReport.attachmentFolderGuid,
				role: "constructionSiteWorksheet"
			});

			if (currConstructionSiteWorksheet) {
				currConstructionSiteWorksheet.set({
					document: uploadedDocument,
					fileName: uploadedDocument.name
				});
			}
			waitBoxComponent.hide();
		});
	}
}

const setConstructionSiteWorksheetDocumentComponent = new SetConstructionSiteWorksheetDocumentComponent();

Shark.registerComponent(setConstructionSiteWorksheetDocumentComponent);

export default setConstructionSiteWorksheetDocumentComponent;
